import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Promo from './views/Promo.vue'
import Account from './views/Account.vue'
import OrdersList from './views/OrdersList.vue'
import NewAccount from './views/NewAccount.vue'
import PasswordRestore from './views/PasswordRestore.vue'
import Policy from './views/Policy.vue'
import PageNotFound from './views/PageNotFound.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/about',
            name: 'about',
            component: About
        },
        {
            path: '/promo',
            name: 'promo',
            component: Promo
        },
        {
            path: '/account',
            name: 'account',
            component: Account
        },
        {
            path: '/orders',
            name: 'orders',
            component: OrdersList
        },
        {
            path: '/new-account',
            name: 'new-account',
            component: NewAccount
        },
        {
            path: '/password-restore',
            name: 'password-restore',
            component: PasswordRestore
        },
        {
            path: '/policy',
            name: 'policy',
            component: Policy
        },
        {
            path: '*',
            name: '404',
            component: PageNotFound
        },
    ]
})
